<template>
  <div v-if="hasPermission(permissions.leadSourcesEdit)">
    <content-header>{{ $t('editLeadSource') }}</content-header>
    <v-content>
      <b-card>
        <b-card-body>
          <form class="forms-sample" @submit.prevent="onSubmit">
            <text-input id="name" :name="$t('name')" :validate="$v" :required="true" :is-loading="isLoading" />
            <submit-input icon="fa-save" :name="$t('save')" :disabled="isLoading"/>
            <is-loading v-if="isLoading" />
          </form>
        </b-card-body>
      </b-card>
    </v-content>
  </div>
</template>

<script>
import Content from "@/components/Content";
import ContentHeader from "@/components/ContentHeader";
import { required } from 'vuelidate/lib/validators'
import IsLoading from "@/components/IsLoading";
import SubmitInput from "@/components/Inputs/SubmitInput";
import TextInput from "@/components/Inputs/TextInput";
import {LeadSource} from "@/models/LeadSource";
import {permissions} from "@/plugins/constants";

export default {
  name: "LeadSourceEdit",
  components: {TextInput, SubmitInput, ContentHeader, 'v-content': Content, IsLoading},
  data() {
    return {
      form: this.$helpers.convertArrayToObject(new LeadSource().fillAbles),
      isLoading: false,
      permissions: permissions
    };
  },
  validations: {
    form: {
      name: {required},
    }
  },
  mounted() {
    this.isLoading = true;
    this.$store.dispatch('leadSources/GET_ONE', this.$route.params.id).then(async (response) => {
      this.form = await response.data;
      this.isLoading = false;
    }).catch(() => this.isLoading = false)
  },
  methods: {
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$pending || this.$v.$error) return false;
      this.isLoading = true;
      this.$store.dispatch('leadSources/UPDATE', {id: this.$route.params.id, form: this.form}).then(() => {
        this.$v.$reset();
        this.$router.push({name: "leadSources"})
      }).catch(() => this.isLoading = false);
    },
  }
}
</script>
